import { jsx as r } from "react/jsx-runtime";
import s from "./user-position-marker.module.less.js";
const t = () => /* @__PURE__ */ r("div", { className: s.wrapper, children: /* @__PURE__ */ r("div", { className: s.dot }) });
export {
  t as UserPositionMarker
};
